// src/router/index.js
import Vue from 'vue'
import store from '../store/index.js'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },

  {
    path: '/',
    component: Dashboard,
    props: true,
    meta: { requiresAuth: true },

    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('../views/Home.vue'),
        props: true,
      },
      {
        path: 'caracterizacion/',
        name: 'CaracterizacionView',
        component: () => import('../views/CaracterizacionView.vue'),
      },
      {
        path: 'rating/',
        name: 'RatingView',
        component: () => import('../views/RatingView.vue'),
      },
      {
        path: 'materiaprima/',
        name: 'MateriaPrimaView',
        component: () => import('../views/MateriaPrimaView.vue'),
      },
      {
        path: 'detallesencuesta/:producerId',
        name: 'DetallesView',
        props: true,
        component: () => import('../views/DetallesView.vue'),
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


// ==========================================================
// 🔐 GLOBAL GUARD DE AUTENTICACIÓN + REGLAS DE ACCESO
// ==========================================================
router.beforeEach((to, from, next) => {

  // 1) Si requiere login y no está autenticado → login
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      return next('/login')
    }
  }

  const userRole = localStorage.getItem("user_role");
  const userPk = localStorage.getItem("user_id");     // PK real
  const selectedYear = store.state.selectedYear;
  const producers = store.state.producers;            // productoresIndex ya cargado del año
  const allowedYears = store.getters.availableYears;

  // ----------------------------------------------------------
  // 2) PROTECCIÓN: Acceso correcto a detalles POR userPk
  // ----------------------------------------------------------
  if (to.name === 'DetallesView') {
    const pid = String(to.params.producerId);         // id anual
    const match = producers.find(p =>
      String(p.id) === pid && String(p.userPk) === String(userPk)
    );

    if (userRole !== 'admin' && !match) {
      console.warn("🚫 Router bloqueó acceso a otro productor:", pid);

      // obtener el id anual real del productor en este año
      const real = producers.find(p => String(p.userPk) === String(userPk));

      return next(real ? `/detallesencuesta/${real.id}` : '/');
    }
  }

  // ----------------------------------------------------------
  // 3) PROTECCIÓN: Vistas generales → año permitido
  // ----------------------------------------------------------
  if (['CaracterizacionView', 'RatingView', 'MateriaPrimaView'].includes(to.name)) {
    if (!allowedYears.includes(selectedYear)) {
      console.warn("🚫 Acceso denegado: año no permitido");
      return next('/');
    }
  }

  next();
});

export default router
